export default __webpack_public_path__ + "static/media/448.75b3c3c1.png";